module.exports = __webpack_public_path__ + "static/communications-content-1-fb76f2170a29e5ab99b00087134e4ca1.png";